import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgReturning = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M2.667 10h-2L4 14.667 7.333 10h-2V6.667A2.667 2.667 0 0 1 8 4h1.333A2.667 2.667 0 0 1 12 6.667v8h2.667v-8a5.333 5.333 0 0 0-5.334-5.334H8a5.333 5.333 0 0 0-5.333 5.334V10z" })
});
export default SvgReturning;
